import {Button, Input} from "@atomaro/ui-kit";
import {CloseIcon, PassHide, PassShow} from "shared/ui/icons";
import {toRem} from "shared/helpers";
import {
  ControlsWrapper,
  HLine, HLineLight,
  ProfileContentWrapper,
  ProfileDrawerContent, ProfileDrawerFooter,
  ProfileDrawerHeader,
  ProfileDrawerTitle, ProfileEditorForm
} from "widgets/profile/ui/styles.ts";
import {Controller} from "react-hook-form";
import {useEditProfile} from "widgets/profile/lib/useEditProfile.ts";
import {useResize} from "../../../../app/lib/hooks/useResize.ts";

type PasswordEditorProps = {
  onClose: () => void;
  onSubmit: () => void;
}

export const PasswordEditor = ({onClose, /* onSubmit */}: PasswordEditorProps) => {
  const {
    control,
    errors,
    showPass,
    showPrevPass,
    changePrevPass,
    changePass,
    setShowPass,
    prevPassValidate,
    setShowPrevPass,
    passValidate,
    repeatPassValidate,
    clearErrors,
    showConfirmPass,
    changeConfirmPass,
    setShowConfirmPass,
    onPassUpdate,
    handleSubmit,
    isLoading,
    reset,
  } = useEditProfile({onClose})
  const { isScreenMd } = useResize();
  
  const prevPassRules = {
    required: 'Введите пароль',
    minLength: {value: 6, message: 'Минимум 6 символов'},
    pattern: {
      value: /[^\s]+/g,
      message: 'Никаких пробелов'
    },
    validate: prevPassValidate
  }
  
  const passRules = {
    required: 'Введите пароль',
    minLength: {value: 6, message: 'Минимум 6 символов'},
    pattern: {
      value: /[^\s]+/g,
      message: 'Никаких пробелов'
    },
    validate: passValidate
  }
  
  const repeatPassRules = {
    required: 'Введите пароль',
    minLength: {value: 6, message: 'Минимум 6 символов'},
    pattern: {
      value: /[^\s]+/g,
      message: 'Никаких пробелов'
    },
    validate: repeatPassValidate
  }
  
  return (
  <>
    {isScreenMd && (<ProfileDrawerHeader>
      <Button
        iconPrefix={<CloseIcon/>}
        variant="secondary"
        colorScheme="neutral"
        style={{alignSelf: 'flex-end', width: !isScreenMd ? toRem(24) : toRem(36)}}
        size={!isScreenMd ? 's' : 'm'}
        onClick={onClose}
      />
      <ProfileDrawerTitle>
        Изменение пароля
      </ProfileDrawerTitle>
      <HLine/>
    </ProfileDrawerHeader>)}
    
    <ProfileEditorForm
      onSubmit={handleSubmit(onPassUpdate)}
    >
    <ProfileDrawerContent>
      <ProfileContentWrapper>
        <Controller
          name="previousPassword"
          control={control}
          rules={prevPassRules}
          render={({field}) => (
            <Input
              name={field.name}
              value={field.value}
              type={showPrevPass ? 'text' : 'password'}
              autoComplete="new-password"
              size="l"
              label="Старый пароль"
              error={errors.previousPassword?.message}
              onChange={event => changePrevPass(event, field)}
              iconSuffix={showPrevPass ? <PassShow /> : <PassHide />}
              onClickIconSuffix={() => setShowPrevPass(!showPrevPass)}
              onFocus={() => clearErrors('password')}
            />
          )}
        />
        <Controller
          name="password"
          control={control}
          rules={passRules}
          render={({field}) => (
            <div style={{ order: 5 }}>
              <Input
                name={field.name}
                value={field.value}
                type={showPass ? 'text' : 'password'}
                autoComplete="new-password"
                size="l"
                label="Новый пароль"
                error={errors.password?.message}
                onChange={event => changePass(event, field)}
                iconSuffix={showPass ? <PassShow /> : <PassHide />}
                onClickIconSuffix={() => setShowPass(!showPass)}
                onFocus={() => clearErrors('password')}
              />
            </div>
          )}
        />
        <Controller
          name="repeatPassword"
          control={control}
          rules={repeatPassRules}
          render={({field}) => (
            <div style={{ order: 6 }}>
              <Input
                name={field.name}
                value={field.value}
                type={showConfirmPass ? 'text' : 'password'}
                size="l"
                label="Подтверждение пароля"
                error={errors.repeatPassword?.message}
                onChange={event => changeConfirmPass(event, field)}
                iconSuffix={showConfirmPass ? <PassShow /> : <PassHide />}
                onClickIconSuffix={() => setShowConfirmPass(!showConfirmPass)}
                onFocus={() => clearErrors('repeatPassword')}
              />
            </div>
          )}
        />
        <HLineLight/>
      </ProfileContentWrapper>
    </ProfileDrawerContent>
    
    <ProfileDrawerFooter>
      <HLine/>
      <ControlsWrapper>
        <Button
          label={"Отменить"}
          style={{order: 0}}
          variant={"ghost"}
          colorScheme="neutral"
          size={"m"}
          onClick={() => {
            reset()
            onClose()
          }}
        />
        <Button
          label={"Сохранить"}
          style={{}}
          disabled={
          isLoading && !!(
            errors.previousPassword?.message || errors.password?.message || errors.repeatPassword?.message
          )
        }
          type='submit'
          variant={"primary"}
          size={"m"}
          onClick={handleSubmit(onPassUpdate)}
        />
      </ControlsWrapper>
    </ProfileDrawerFooter>
    </ProfileEditorForm>
  </>
)}